import styled from 'styled-components';

import { Typography } from '@useblu/ocean-react';

import {
  colorInterfaceLightUp,
  spacingInlineXs,
  spacingInlineSm,
  spacingInlineXl,
  spacingInlineXxl,
  borderRadiusMd,
} from '@useblu/ocean-tokens/web/tokens';

import { breakpointTo, bpMedium } from 'tokens';

export const AccordionContainer = styled.div`
  background-color: ${colorInterfaceLightUp};
  border-radius: ${borderRadiusMd};
  display: flex;
  flex-direction: column;
  margin: ${spacingInlineXxl} 0 ${spacingInlineXl};
  padding: ${spacingInlineSm};
  width: 530px;

  @media ${breakpointTo(bpMedium)} {
    margin: ${spacingInlineXxl} 0 0;
    width: 100%;
  }
`;

export const FaqTitle = styled(Typography).attrs(() => ({
  variant: 'description',
}))`
  &&& {
    padding: 0 ${spacingInlineXs};
  }
`;
